import {Component, Input, OnInit, inject} from '@angular/core';
import {reformatDate, reformatDateTime} from 'src/app/_utils/lang';
import {I18nService} from '../../../_services/gui/i18n.service';
import {Observable} from 'rxjs';
import {BizLumbSubTradeAccountDet} from '../../../_data/reports/lumbermens/lumbermens-business';
import {AsyncPipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-lumbermens-trade-account-det',
    templateUrl: './lumbermens-trade-account-det.component.html',
    styleUrls: ['./lumbermens-trade-account-det.component.scss'],
    imports: [AsyncPipe, TranslateModule]
})
export class LumbermensTradeAccountDetComponent implements OnInit {

  @Input('lumbermensTradeAccountDet') det: BizLumbSubTradeAccountDet = {} as BizLumbSubTradeAccountDet;

  //Util methods used in the template
  reformatDate = reformatDate;
  reformatDateTime = reformatDateTime;

  i18nService = inject(I18nService);

  ngOnInit() {
  }

  getPaymentTerms(): string {
    if(this.i18nService.currentLangShortCode === 'FR' && this.det.fPaymentTerm != null) {
      return this.det.fPaymentTerm;
    } else {
      return this.det.paymentTerm;
    }
  }

  getRecentPaymentHistory(): string {
    if(this.i18nService.currentLangShortCode === 'FR' && this.det.fRecentExp != null) {
      return this.det.fRecentExp;
    } else {
      return this.det.recentExp;
    }
  }

  getPastPaymentHistory(): string {
    if(this.i18nService.currentLangShortCode === 'FR' && this.det.fPaymentExp != null) {
      return this.det.fPaymentExp;
    } else {
      return this.det.paymentExp;
    }
  }

  // This section you include the future amount in the total
  getTotalOwing(): Observable<string> {
    const totalAmount = this.det.dueCurrent + this.det.due30 + this.det.due60 + this.det.due90 + this.det.due120 + this.det.futureReceivables;
    return this.i18nService.formatCurrency(totalAmount);
  }

}
